<template>
  <div class="readon-homepage">
    <router-view />
    <Loading />
    <Toast />
  </div>
</template>

<script>
import { provide } from 'vue';
import Loading from '../../components/common/loading.vue';
import '../../views/homepage/index.scss';
import Toast from '../../components/common/toast.vue';

export default {
  setup() {
    provide('theme', 'light');
    return {};
  },
  created() {
    console.log(this.$route, this.$router);
  },
  name: 'App',
  components: { Loading, Toast },
};
</script>

<style>
#app {
  font-size: 26px;
}
.readon-homepage {
}
html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #000;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.wallet-key-txt {
  font-size: 26px;
}
.logo {
  background: url('../../assets/logo.svg') no-repeat center;
  background-size: contain;
}
.eth_icon {
  background: url('../../assets/eth_icon.svg') no-repeat center;
  background-size: contain;
}
.color_title {
  display: inline-block;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 124.19%;
  letter-spacing: 0.015em;
  background: linear-gradient(92.06deg, #41b5da 7.25%, #9a76c4 95.52%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
#walletconnect-wrapper {
  font-size: 20px;
}
</style>
